var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-wrapper"},[_c('HeaderBlock'),_c('div',{staticClass:"content-scroll"},[_c('router-view'),_c('FooterBlock')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }